import React from 'react'

export const Header = () => {
  return (
    <div className='header'>
      <div>
        <h2>"Qishloq xo‘jaligini mexanizatsiyalash" fakulteti</h2>
        <h1>"Traktorlar va avtomobillar" kafedrasi</h1>
      </div>
    </div>
  )
}
